import AnalyticsTab from './AnalyticsTab';


export default {
  'superAdminAnalytics': {
    screen: AnalyticsTab,
  },
};